import api from './api';

export const clubDocumentApi = {
  // UNIFIED Templates API - Auto-detects scope from user context (platform vs club)
  // Backend auto-detects: platform admin → platform templates, club admin → club templates

  // Get template metadata (categories, types, common fields)
  getTemplateMetadata: () =>
    api.get('/api/club-documents/template-metadata'),

  // Get templates (unified - works for both platform and club admins)
  getTemplates: () =>
    api.get('/api/club-documents/templates'),

  getTemplate: (templateId) =>
    api.get(`/api/club-documents/templates/${templateId}`)
      .then(data => ({ success: true, data }))
      .catch(error => ({ success: false, error: error.message })),

  // Create template (unified - auto-detects scope)
  createTemplate: (templateData) =>
    api.post('/api/club-documents/templates', templateData),

  // Update template (unified - auto-detects scope)
  updateTemplate: (templateId, templateData) =>
    api.put(`/api/club-documents/templates/${templateId}`, templateData),

  // Delete template (unified - auto-detects scope)
  deleteTemplate: (templateId) =>
    api.delete(`/api/club-documents/templates/${templateId}`),

  copyPlatformTemplate: (platformTemplateId, customizations = {}) =>
    api.post('/api/club-documents/templates/copy', {
      platform_template_id: platformTemplateId,
      customizations
    }),

  generateTestPdf: async (testData) => {
    const url = `${process.env.REACT_APP_API_URL || ''}/api/club-documents/templates/test-pdf`;
    const token = localStorage.getItem('authToken');

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      body: JSON.stringify(testData)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to generate test PDF: ${errorText}`);
    }

    return response.arrayBuffer();
  },

  // User Documents - Context-based (user from JWT, tenant from Host header)
  getMyDocuments: () =>
    api.get('/api/club-documents/my-documents'),

  getMyDocumentStatus: () =>
    api.get('/api/club-documents/my-documents/status'),

  getDocumentDetails: (documentId) =>
    api.get(`/api/club-documents/my-documents/${documentId}`),

  downloadDocument: (filename) =>
    api.get(`/api/club-documents/download/${filename}`, {
      responseType: 'blob'
    }),

  // Tasks - Context-based (user from JWT, tenant from Host header)
  getMyDocumentTasks: () =>
    api.get('/api/club-documents/my-document-tasks')
};

export default clubDocumentApi;